import { useAuthStore } from '@host/auth'
import { Container, Spinner } from '@prismeet/react'
import { Navigate, Outlet, useLocation } from 'react-router'

import { DEFAULT_AUTHENTICATED_ROUTE, ROUTES } from './constants'

/**
 * Экран ожидания, пока читается хранилище.
 *
 * Ровно один кадр, поэтому без скелетонов и текста: подпись «загрузка»,
 * мелькнувшая на 80 мс, раздражает сильнее, чем её отсутствие.
 */
function SessionGate() {
  return (
    <Container
      display="flex"
      align="center"
      justify="center"
      style={{ minHeight: '100dvh' }}
      aria-busy="true"
    >
      <Spinner size="lg" />
    </Container>
  )
}

/**
 * Пускает дальше только вошедших.
 *
 * Проверка живёт в компоненте, а не в лоадере роута: сессия хранится
 * в React-контексте приложения, до которого лоадеры react-router
 * принципиально не дотягиваются.
 */
export function RequireAuth() {
  const status = useAuthStore((state) => state.status)
  const location = useLocation()

  if (status === 'idle' || status === 'loading') return <SessionGate />

  if (status !== 'authenticated') {
    // Куда человек шёл — запоминаем, чтобы после входа вернуть его туда,
    // а не на дефолтную ленту.
    return <Navigate to={ROUTES.login} state={{ from: location }} replace />
  }

  return <Outlet />
}

/** Обратный гвард: вошедшему нечего делать на форме входа. */
export function RedirectIfAuthenticated() {
  const status = useAuthStore((state) => state.status)

  if (status === 'idle' || status === 'loading') return <SessionGate />
  if (status === 'authenticated') return <Navigate to={DEFAULT_AUTHENTICATED_ROUTE} replace />

  return <Outlet />
}
